<template>
    <SettingsTabs class="mt-12" tab-key="team-settings-api-tokens">
        <PersonalApiToken />
    </SettingsTabs>
</template>
<script setup lang="ts"></script>
